<template>
  <div class="wrap">
    <div
      class="subheader"
      ref="subheader"
    >
      <div class="backdrop"></div>
      <div class="subheader-wrap">

        <div
          class="subheader__header"
          v-if="displayName"
        >
          {{ $t('errands.welcome') }} {{ displayName }}!
          <div
            class="subheader__header small"
            v-if="currentUserCompany"
          >
            <v-icon
              light
              class="place"
            >place</v-icon>{{ currentUserCompany._name }}
          </div>
        </div>

        <div class="search__container">
          <v-text-field
            class="search"
            v-model="searchText"
            :placeholder="$t('errands.searchErrand')"
            solo
            append-icon="search"
          ></v-text-field>
        </div>

        <div class="filters">

          <v-select
            :items="filterData.assignments"
            item-value="data"
            solo
            :value="selectedSearchFilters.propertyManagerFilter"
            @input="changeFilter('propertyManagerFilter', ...arguments)"
          ></v-select>

          <v-select
            :items="filterData.caseStatus"
            item-value="data"
            solo
            :value="selectedSearchFilters.caseStatus"
            @input="changeFilter('caseStatus', ...arguments)"
          ></v-select>

          <v-select
            :items="filterData.workTypes"
            :multiple="true"
            solo
            item-value="data"
            :value="selectedSearchFilters.workTypes"
            :placeholder="selectedSearchFilters.workTypes.length === 0 ? $t('createErrand.typeOfDamage') : ''"
            @input="changeFilter('workTypes', ...arguments)"
          >
            <template v-slot:selection="{ item, index }">
              <span v-if="index === 0">{{ item.text }} </span>
              <span
                v-if="index === 1"
                class="grey--text caption"
                style="margin-left: 5px;"
              >(+{{ selectedSearchFilters.workTypes.length - 1 }}
                <!-- others -->)
              </span>
            </template>
          </v-select>
          <div class="new-case-export-btns">
            <v-btn
              v-if="isBusinessPartner"
              small
              class="primary--text text--darken-2 mr-1"
              @click.prevent="createErrand"
            >
              <v-icon small>add</v-icon>
              {{ $t('errands.addNewCase') }}
            </v-btn>

            <v-btn
              small
              class="primary--text text--darken-2 hidden-xs-only"
              :class="{ 'export-cases--solo': !isBusinessPartner }"
              @click.prevent="exportCases"
            >
              <v-icon small>file_download</v-icon>
              {{ $t('errands.exportCases') }}
            </v-btn>
          </div>

        </div>
      </div>
    </div>

  </div>
</template>

<script>
import _ from 'lodash'
import submitErrandService from '@/core/services/submit-errand-service'
import httpService from '@/core/http-service'
import FileSaver from 'file-saver'
import $ from 'jquery'
import toast from '@/core/toasts'
import constants from '@/core/constants'

export default {
  props: ['model'],
  methods: {
    changeFilter(key, value) {
      this.$store.dispatch('setSearchFilters', { key, value })
    },
    createErrand() {
      const newErrand =
        _.find(this.$store.getters.createdErrand) ||
        submitErrandService.create(this.currentUserCompany)
      this.$router.push(`/new/${newErrand.request.external_id_1}`)
    },
    exportCases() {
      toast.success(this.$t('errands.exportCaseDownloadMessage'), {
        duration: 10000
      })
      const params = $.param({
        token: this.$store.getters.authenticationData.accessToken,
        channel: _.get(this.currentUserCompany, 'channel'),
        accessGroup: _.get(this.currentUserCompany, 'accessGroup'),
        isoCode: this.currentIsoCode
      })
      FileSaver.saveAs(
        `${httpService.baseUrl}/api/v1/rpc/errand/downloadErrands?${params}`
      )
    }
  },
  computed: {
    searchText: {
      get() {
        return this.$store.getters.searchText
      },
      set(value) {
        this.$store.dispatch('setSearchFilters', { key: 'searchText', value })
      }
    },
    selectedSearchFilters() {
      return this.$store.getters.searchFilters
    },
    filterData() {
      return {
        workTypes: _.map(this.$store.getters.workTypes, damageType => ({
          text: damageType.description,
          data: damageType.id
        })),
        assignments: [
          { text: this.$t('errands.allErrands'), data: '*' },
          { text: this.$t('errands.myErrands'), data: this.username }
        ],
        caseStatus: [
          {
            text: this.$t('errands.activeCases'),
            data: [
              constants.fsmRequestStatus.pendQuote,
              constants.fsmRequestStatus.open,
              constants.fsmRequestStatus.inProcess,
              constants.fsmRequestStatus.pendComp,
              constants.apps10RequestStatus.workRequest,
              constants.apps10RequestStatus.prepared,
              constants.apps10RequestStatus.started,
              constants.apps10RequestStatus.workDone,
              constants.apps10RequestStatus.released
            ].join('|')
          },
          {
            text: this.$t('errands.closedCases'),
            data: [
              constants.apps10RequestStatus.finished,
              constants.fsmRequestStatus.complete,
              constants.fsmRequestStatus.closed
            ].join('|')
          }
        ]
      }
    }
  },
  mounted() {
    this.$store.dispatch('setSearchFilters', {
      key: 'caseStatus',
      value: this.filterData.caseStatus[0].data
    })
    this.$store.dispatch('setSearchFilters', {
      key: 'assignments',
      value: this.filterData.assignments[0].data
    })
  }
}
</script>

<style lang="scss" scoped>
.search__container {
  padding: 0 measure(m);
}
.place {
  color: color(white) !important;
  margin-right: measure(xxs);
}
.subheader-wrap {
  flex-direction: column;
}
.subheader {
  background-color: color(primary);
  left: 0;
  width: 100%;

  @media #{$mq-mobile-only} {
    z-index: 29;
  }

  &:before,
  &:after {
    content: "";
    display: block;
    width: measure(m);
    height: calc(100% - 0.9375rem);
    position: absolute;
    top: 0;
    z-index: 40;
    pointer-events: none;
    @media #{$mq-swapToDesktop} {
      display: none;
    }
  }

  &:before {
    left: 0;
    // todo css
    // background-image: linear-gradient(to left, rgba(color(primary), 0.001) 0%, rgba(color(primary), 1) 100%);
  }

  &:after {
    right: 0;
    // background-image: linear-gradient(to right, rgba(color(primary), 0.001) 0%, rgba(color(primary), 1) 100%);
  }
}
.subheader-wrap {
  padding-left: 0;
  padding-right: 0;
  > .dd {
    z-index: 2;
  }
  > .dd:after {
    display: none;
  }
}
.filters .filter {
  margin-right: measure(xs);
}
.filters {
  position: relative;
  padding-left: measure(m);
  padding-right: measure(m);
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: measure(xxs);

  @media #{$mq-mobile-only} {
    flex-wrap: nowrap;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    -ms-overflow-style: -ms-autohiding-scrollbar;
    &::-webkit-scrollbar {
      display: none;
      width: 0;
      -webkit-appearance: none;
    }
  }

  @media #{$mq-medium} {
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;
  }
}

.filters .v-select {
  @media #{$mq-swapToDesktop} {
    max-width: 13rem;
    margin-right: measure(xxs);
  }
}

@media #{$mq-swapToDesktop} {
  .subheader {
    position: relative;
    left: initial;
    height: auto;
  }
  .spacer {
    display: none;
  }
}

.new-case-export-btns {
  margin-left: auto;
  @media #{$mq-to-medium} {
    margin-left: 0;
  }
}

.subheader__header {
  display: none;
}

.backdrop {
  display: none;
}

@media #{$mq-swapToDesktop} {
  .backdrop {
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0.18;

    background-image: url("~@/assets/images/polygon-banner-graphic-new.png");
    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;
  }
  .subheader {
    padding-bottom: 45px;
    background-color: color(primary);
  }
  .subheader__header {
    display: block;
    padding: 40px measure(m);
    font-size: 2.125rem;
    color: color(white);
    &.small {
      font-size: 1.2rem;
      padding: 10px 0 0;
    }
  }
}
</style>

<style lang="scss">
.search.v-text-field.v-text-field--enclosed
  > .v-input__control
  > .v-input__slot {
  $border-radius: 0.25rem;
  $border-radius-mobile: 1.5rem;
  border-radius: $border-radius-mobile;
  padding-left: 16px;
  margin-bottom: measure(m);
  box-shadow: none;

  @media #{$mq-swapToDesktop} {
    border-radius: $border-radius;
  }
}
.search.v-text-field.v-text-field--enclosed .v-text-field__details {
  display: none;
}
</style>
